export default {
  mounted() {
    var href = location.href
    if (href) {
      var links = document.getElementsByTagName('link')
      for (var i = 0; i < links.length; i++) {
        if (links[i].rel) {
          if (links[i].rel.toLowerCase() === 'canonical') {
            links[i].setAttribute('href', href)
          }
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/util/canonical.js